import type { DocumentStatsType } from './types/document-stats-type';

export const widgetKeys = {
  widgets: ['widgets'] as const,

  documentStats: () => [widgetKeys.widgets, 'documentStats'] as const,
  documentStatsDetail: (showAll: boolean, type: DocumentStatsType) =>
    [...widgetKeys.documentStats(), showAll, type] as const,

  documentHits: () => [widgetKeys.widgets, 'documentHits'] as const,
  documentHitsDetail: (signDateInterval: { from: number; to: number }, showAll: boolean) => [
    widgetKeys.documentHits,
    signDateInterval,
    showAll,
  ],

  topPerformers: () => [widgetKeys.widgets, 'topPerformers'],
  topPerformersDetail: (interval: { from: number; to: number }) => [
    ...widgetKeys.topPerformers(),
    interval,
  ],

  activeDealTimes: () => [widgetKeys.widgets, 'activeDealTimes'],
  activeDealTimesDetail: (interval: { from: number; to: number }, showAll: boolean) => [
    ...widgetKeys.activeDealTimes(),
    interval,
    showAll,
  ],
};
